export const UNEXPECTED_EXCEPTION = "UNEXPECTED_EXCEPTION";
